module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_14.51153248.jpg";